import MyPurchases from ".";

export default function MyPurchasesExamples() {
  return <MyPurchases />;
}
